import { Col, Row } from "reactstrap";
import logo from "../assets/imgs/pdf-logo.png";
import adminBg from "../assets/imgs/admin-bg.png";

const AuthWrapper = ({ title, description, children, size = 5 }) => {
  return (
    <div className="min-vh-100 d-flex flex-column" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <Row className="w-100 m-0 flex-grow-1">
        {/* Left Side: Branding and Visuals */}
        <Col
          lg="6"
          className="d-none d-lg-flex flex-column justify-content-center align-items-center position-relative text-white p-5"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(0, 80, 157, 0.85) 0%, rgba(24, 40, 72, 0.95) 100%), url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Glassmorphism Card for Text */}
          <div
            className="text-center p-5 rounded-4"
            style={{
              zIndex: 2,
              maxWidth: '85%',
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(15px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)'
            }}
          >
            <div className="bg-white d-inline-flex p-3 rounded-4 shadow-lg mb-4">
              <img src={logo} height={60} width="auto" alt="Techmicro Logo" style={{ objectFit: 'contain' }} />
            </div>
            <h1 className="fw-bolder mb-3 display-5" style={{ letterSpacing: "-0.03em", textShadow: "0 2px 10px rgba(0,0,0,0.2)" }}>
              Information Management System
            </h1>
            <p className="fs-5 opacity-75 mb-0 fw-light">
              Streamline your workflow with seamless inventory, order, and data management.
            </p>
          </div>
        </Col>

        {/* Right Side: Auth Form */}
        <Col
          lg="6"
          xs="12"
          className="d-flex flex-column justify-content-center align-items-center bg-white position-relative"
        >
          <div className="w-100 p-4 p-md-5" style={{ maxWidth: '500px' }}>
            {/* Mobile Title & Logo */}
            <div className="d-lg-none text-center mb-5">
              <div className="bg-light d-inline-flex p-2 rounded-3 shadow-sm mb-3">
                <img src={logo} height={45} width="auto" alt="Techmicro Logo" />
              </div>
              <h4 className="fw-bold text-dark mb-0">Techmicro | IMS</h4>
            </div>

            <div className="mb-4 text-center text-lg-start">
              <h2 className="fw-bold text-dark mb-2" style={{ letterSpacing: "-0.02em" }}>
                {title}
              </h2>
              <p className="text-muted fs-6">{description}</p>
            </div>

            <div className="mt-4">
              {children}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AuthWrapper;

